/* eslint-disable react/no-multi-comp */
import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'material-ui';
import { withStyles } from 'material-ui/styles';
import Dialog, { DialogTitle } from 'material-ui/Dialog';
import { Button, DialogActions, DialogContent } from 'material-ui';
import { translate } from 'react-i18next';
import { registerPopUpWidget } from './PopUpDialogController';
import { Grid } from 'material-ui';

const styles = {
    root: {
        backgroundColor: 'white',
        color: 'var(--primary-color)'
    },
    dialogTitle: {
        fontWeight: '300',
        fontSize: '28px'
    },
    dialogPaper: {
        minHeight: '90vh',
        maxHeight: '90vh',
        width: '640px'
    },
};
const ContactInfoRender = (props) => {
    let { contactItem } = props;
    return (
        <div className='cmsContactInfoRender'>
            <Typography className="title" variant="title">{contactItem.label}</Typography>
            <Typography className="reference" variant="subtitle">{contactItem.reference}</Typography>
            <Typography className="email" variant="subtitle"><a href={'mailto:' + contactItem.email}>{contactItem.email}</a></Typography>
            <Typography className="tel" variant="subtitle">{contactItem.telephone}</Typography>
            <hr />
        </div>
    );
};
/**
 * PopUpInfoDialog para el CMS.
 *
 * @author Luciano Bustos
 *
 */
class PopUpInfoDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            contactData: [],
            titleName: '',
        };
        registerPopUpWidget('cmsPopUpInfoDialog', this);
    }

    displayContent = (data) => {
        let widgetData = { ...data };
        let title = data.title;
        //remove labels header
        this.setState({
            titleName: title,
            contactData: widgetData.contactOptions
        }, () => {
            this.props.onOpen();
        });
    }

    handleClose = () => {
        this.props.onClose(this.state);
    };

    handleCancel = () => {
        this.showBodyScrollBars();
        this.props.onClose(null);
    };

    showBodyScrollBars = () => {
        // dialog has side-effect that prevents body from scrolling if this not checked
        //document.querySelector('body').style.overflow = 'visible';
    };

    handleEnter = () => {
        this.hideBodyScrollBars();
    };

    hideBodyScrollBars() {
        // dialog has a side-effect if this not checked
        //document.querySelector('body').style.overflow = 'hidden';
    }


    render() {
        const { classes, onClose, t, ...other } = this.props;
        return (
            <Dialog
                open={true}
                onClose={this.handleClose}
                onEnter={this.handleEnter}
                aria-labelledby="simple-dialog-title"
                classes={{ paper: classes.dialogPaper }}
                PaperProps={{
                    classes: {
                        root: classes.root
                    }
                }
                }
                {...other}>
                <DialogTitle disableTypography={true} id="pop-dialog-title"
                    className={classes.dialogTitle}>
                    {this.state.titleName}
                </DialogTitle>
                <DialogContent>
                    <Grid container xs={12}>
                            {this.state.contactData.slice(0, 5).map(item => {
                                return <ContactInfoRender contactItem={item} />;
                            })
                            }
                            {this.state.contactData.slice(5).map(item => {
                                return <ContactInfoRender contactItem={item} />;
                            })
                            }
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleCancel} color="primary" variant="raised">{t('COMMON.CLOSE')}</Button>
                </DialogActions>
            </Dialog>
        );
    }
}

PopUpInfoDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onClose: PropTypes.func,
    onOpen: PropTypes.func,
};
export default translate('translations')(withStyles(styles)(PopUpInfoDialog));


// WEBPACK FOOTER //
// ./src/cms/PopUpInfoDialog.js